import * as React from 'react';
import { useEffect, useState } from 'react';
import Table from '@mui/material/Table';
import TableBody from '@mui/material/TableBody';
import TableCell from '@mui/material/TableCell';
import TableContainer from '@mui/material/TableContainer';
import TableHead from '@mui/material/TableHead';
import TableRow from '@mui/material/TableRow';
import Paper from '@mui/material/Paper';
import { useQuery } from 'react-query';
import Avatar from '@mui/material/Avatar';
import apiClient from '../../request/http-common';
import Container from '@mui/material/Container';
import Typography from '@mui/material/Typography';
import { Button, IconButton, Dialog, DialogActions, DialogContent, DialogContentText, DialogTitle } from '@mui/material';
import EditIcon from '@mui/icons-material/Edit';
import DeleteIcon from '@mui/icons-material/Delete';
import { Link as RouterLink } from 'react-router-dom';
import { useMutation, useQueryClient } from 'react-query';

export default function ListAddresses() {
    const [addresss, setaddresss] = useState(null);
    const [deleteDialogOpen, setDeleteDialogOpen] = useState(false);
    const [addressToDelete, setAddressToDelete] = useState(null);
    const queryClient = useQueryClient();
    const { isLoading: isLoadingaddresss, refetch: getaddresss } = useQuery(
        "show-address",
        async () => {
          return await apiClient.get("/api/show-address");
        },
        {
          enabled: false,
          onSuccess: (res) => {
            if (res.data.status === 'success') {
                setaddresss(res.data.wallets);
                const event2 = new Event('processed');
                window.dispatchEvent(event2);
            }
          },
          onError: (err) => {
            // console.log(err.response?.data || err);
          },
        }
      );
    
      useEffect(() => {
        getaddresss() 
        if (isLoadingaddresss) {
            const event3 = new Event('processing');
            window.dispatchEvent(event3);
        }
      }, []);

    // Delete address mutation
    const { mutate: deleteAddress, isLoading: isDeleting } = useMutation(
        async (addressId) => {
            return await apiClient.delete(`/api/delete-wallet/${addressId}`);
        },
        {
            onSuccess: (res) => {
                localStorage.setItem('notification', JSON.stringify({
                    message: res.data.message || 'Address deleted successfully',
                    type: 'success'
                }));
                const event = new Event('newMessage');
                window.dispatchEvent(event);
                
                // Refresh the addresses list
                getaddresss();
                setDeleteDialogOpen(false);
                setAddressToDelete(null);
            },
            onError: (err) => {
                localStorage.setItem('notification', JSON.stringify({
                    message: err.response?.data?.message || 'Failed to delete address',
                    type: 'error'
                }));
                const event = new Event('newMessage');
                window.dispatchEvent(event);
            }
        }
    );

    const handleDeleteClick = (address) => {
        setAddressToDelete(address);
        setDeleteDialogOpen(true);
    };

    const handleDeleteConfirm = () => {
        if (addressToDelete) {
            deleteAddress(addressToDelete.id);
        }
    };

    const handleDeleteCancel = () => {
        setDeleteDialogOpen(false);
        setAddressToDelete(null);
    };

  const getDate = (date) => new Date(date).toDateString();
  return (
    <div style={{marginTop: '75px'}}>
    <Container>
        <Typography  mt={4} mb={2} sx={{ fontWeight: 'bold', fontSize: 20, textAlign: 'center', textTransform: 'uppercase' }} gutterBottom variant="h6" component="div">
        
        {isLoadingaddresss? 'Loading addresss...' : 'List of Wallet addresses'}
      </Typography>
    <TableContainer component={Paper}>
        
      {addresss !== null &&
      <Table sx={{ minWidth: '100%' }} size="small" aria-label="a dense table">
      <TableHead>
        <TableRow>
        
        <TableCell>Icon</TableCell>
        <TableCell>Name</TableCell>
        <TableCell align="right">Address</TableCell>
        <TableCell align="right">Type</TableCell>
        <TableCell align="right">Display Area</TableCell>
        <TableCell align="right">Actions</TableCell>
        </TableRow>
      </TableHead>
      <TableBody>
        {addresss.map((address) => (
          <TableRow
            key={address.id}
            sx={{ '&:last-child td, &:last-child th': { border: 0 } }}
          >
            <TableCell>
              <Avatar 
                alt={address.coin_name}
                src={address.image || `https://assets.coincap.io/assets/icons/${address.coin_name.toLowerCase()}@2x.png`}
                onError={(e) => {
                  // Fallback to dynamic image if custom image fails to load
                  e.target.src = `https://assets.coincap.io/assets/icons/${address.coin_name.toLowerCase()}@2x.png`;
                }}
                sx={{ width: 32, height: 32 }}
              />
            </TableCell>
            <TableCell component="th" scope="row">
            {address.coin_name}
            </TableCell>
            <TableCell align="right">{address.address}</TableCell>
            <TableCell align="right">{address.wallet_type}</TableCell>
            <TableCell align="right">{address.display_area}</TableCell>
            <TableCell align="right">
              <Button 
                component={RouterLink} 
                to={`/edit-address/${address.id}`} 
                startIcon={<EditIcon />}
                size="small"
                sx={{ mr: 1 }}
              >
                Edit
              </Button>
              <IconButton
                color="error"
                onClick={() => handleDeleteClick(address)}
                size="small"
              >
                <DeleteIcon />
              </IconButton>
            </TableCell>
          </TableRow>
        ))}
      </TableBody>
    </Table>
      }
      
    </TableContainer>

    {/* Delete Confirmation Dialog */}
    <Dialog
      open={deleteDialogOpen}
      onClose={handleDeleteCancel}
      aria-labelledby="delete-dialog-title"
      aria-describedby="delete-dialog-description"
    >
      <DialogTitle id="delete-dialog-title">
        Confirm Delete
      </DialogTitle>
      <DialogContent>
        <DialogContentText id="delete-dialog-description">
          Are you sure you want to delete the address "{addressToDelete?.coin_name}"? 
          This action cannot be undone.
        </DialogContentText>
      </DialogContent>
      <DialogActions>
        <Button onClick={handleDeleteCancel} color="primary">
          Cancel
        </Button>
        <Button 
          onClick={handleDeleteConfirm} 
          color="error" 
          variant="contained"
          disabled={isDeleting}
        >
          {isDeleting ? 'Deleting...' : 'Delete'}
        </Button>
      </DialogActions>
    </Dialog>

    </Container>
    </div>
  );
}